import React from 'react';
import styled from '@emotion/styled';
import packageJson from '../../../package.json';

const Text = styled(`div`)`
   color: ${(props) => props.white && '#fff'};
   font-family: 'DBHeavent';
   text-align: center;
   font-size: ${(props) => (props.size ? props.size : '1.1rem')};
`;
const Copyright = ({ white, size }) => {
   return (
      <Text white={white} size={size}>
         {'Copyright © '}
         <span>
            {process.env.REACT_APP_COPYRIGHT} V.
            {process.env.REACT_APP_DISPLAY_VERSION}
         </span>
      </Text>
   );
};
export default Copyright;
